<template>
  <div :class="{ 'm-4 <lg:pt-8': hasAnyNotification }">
    <vf-notification v-if="inventoryError" class="mt-4" :dismissible="false" type="error">
      {{ inventoryError.message }}
    </vf-notification>
    <vf-notification
      v-if="dialogNotification.message"
      class="mt-4"
      :type="dialogNotification.type"
      @close="resetNotification"
    >
      {{ dialogNotification.message }}
    </vf-notification>
  </div>
</template>

<script lang="ts" setup>
const {
  dialogNotification,
  inventoryError,
  resetNotification
} = usePdp()

const hasAnyNotification = computed(() => inventoryError.value || dialogNotification.message)
</script>
